import type { BoardCard } from "../../../../lib/giftingRules";
import { STAGE_NAMES, ageIsLate, ageLabel } from "../../../../lib/giftingRules";
import { GfAvatar, GfStageBar } from "../../ui/GfUi";
import type { CardInfo } from "./model";

/** 要対応カード（通常サイズ）。デザイン: 白・枠 #E4E2DC・選択時は primary の枠＋外枠 */
export function KanbanCard({
  card,
  info,
  selected,
  onOpen,
}: {
  card: BoardCard;
  info: CardInfo;
  selected: boolean;
  onOpen: () => void;
}) {
  const { entry: e, action, age } = card;
  return (
    <button type="button" className={`gf-kcard${selected ? " is-selected" : ""}`} onClick={onOpen}>
      <span className="gf-kc-top">
        <GfAvatar name={info.creatorName} size={28} />
        <span className="gf-kc-id">
          <span className="gf-kc-name">{info.creatorName}</span>
          <span className="gf-kc-deal">{info.campaignName}</span>
        </span>
        {action && <span className="gf-kc-act">{action.label}</span>}
      </span>
      <span className="gf-kc-prog">
        <GfStageBar stage={e.stage} height={5} />
        <span className="gf-kc-stage">
          <span className="gf-kc-stage-name">{STAGE_NAMES[e.stage]}</span>
          <span className={ageIsLate(age, e.stage) ? "is-late" : ""}>{ageLabel(age)}</span>
        </span>
      </span>
      {info.autoText && (
        <span className="gf-kc-auto" title={info.autoTitle ?? undefined}>
          <span className="gf-dot" />
          {info.autoText}
        </span>
      )}
      <span className="gf-kc-foot">
        <span>{info.terms}</span>
        <span className="gf-kc-media">
          {info.media.map((m) => (
            <span key={m} className="gf-mono">
              {m}
            </span>
          ))}
        </span>
      </span>
    </button>
  );
}
